module.exports = __webpack_public_path__ + "img/img-15.f5fd38c9.png";